// extracted by mini-css-extract-plugin
module.exports = {"message":"style_message__1MhCl","icon":"style_icon__yHz9_","title":"style_title__2caMa"};